import axios from 'axios';


export const api = axios.create({
  // baseURL: 'http://arc.linfer.jp:27728/',
  baseURL: process.env.NODE_ENV === 'production' ? undefined : 'http://localhost:8180/',
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
  responseType: 'json',
});
